<template>
  <div class="pay-result-page">
    <div class="result-content">
      <div class="result-icon success">
        <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
          <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" fill="#07c160"/>
        </svg>
      </div>
      <h2 class="result-title">支付成功</h2>
      <p class="result-desc">您的订单已支付成功，感谢您的使用</p>
      
      <div class="order-info" v-if="orderInfo">
        <div class="info-item">
          <span class="info-label">订单号：</span>
          <span class="info-value">{{ orderInfo.mchOrderNo || '-' }}</span>
        </div>
        <div class="info-item" v-if="orderInfo.amount">
          <span class="info-label">支付金额：</span>
          <span class="info-value amount">￥{{ (orderInfo.amount / 100).toFixed(2) }}</span>
        </div>
        <!-- <div class="info-item" v-if="orderInfo.mchName">
          <span class="info-label">商户名称：</span>
          <span class="info-value">{{ orderInfo.mchName }}</span>
        </div> -->
      </div>

      <div class="result-actions">
        <button class="btn-primary" @click="handleReturn">返回商户</button>
        <button class="btn-secondary" @click="handleClose">关闭页面</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaySuccess',
  data () {
    return {
      orderInfo: null
    }
  },
  mounted () {
    // 从路由参数或查询参数获取订单信息
    const params = this.$route.params
    const query = this.$route.query
    
    this.orderInfo = {
      mchOrderNo: params.mchOrderNo || query.mchOrderNo || '',
      amount: params.amount || query.amount || null,
      mchName: params.mchName || query.mchName || ''
    }
  },
  methods: {
    handleReturn () {
      const returnUrl = this.$route.query.returnUrl
      if (returnUrl) {
        location.href = returnUrl
      } else {
        this.handleClose()
      }
    },
    handleClose () {
      // 尝试关闭窗口，如果无法关闭则返回上一页
      if (window.opener) {
        window.close()
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="css" scoped>
.pay-result-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.result-content {
  background: #fff;
  border-radius: 16px;
  padding: 40px 30px;
  max-width: 500px;
  width: 100%;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

.result-icon {
  width: 100px;
  height: 100px;
  margin: 0 auto 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f0f9ff;
}

.result-icon.success {
  background: #f0fdf4;
}

.result-icon svg {
  width: 60px;
  height: 60px;
}

.result-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin: 0 0 12px;
}

.result-desc {
  font-size: 16px;
  color: #666;
  margin: 0 0 32px;
  line-height: 1.5;
}

.order-info {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 20px;
  margin: 0 0 32px;
  text-align: left;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #e9ecef;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  font-size: 14px;
  color: #666;
}

.info-value {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.info-value.amount {
  font-size: 18px;
  color: #07c160;
  font-weight: bold;
}

.result-actions {
  display: flex;
  gap: 12px;
}

.btn-primary,
.btn-secondary {
  flex: 1;
  height: 48px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
}

.btn-primary:active {
  opacity: 0.9;
  transform: scale(0.98);
}

.btn-secondary {
  background: #f5f5f5;
  color: #666;
}

.btn-secondary:active {
  background: #e9e9e9;
}
</style>

